export const spacing = {
  wide: [5, 5, 5, 6],
  narrow: [4, 4, 4, 5],
};
